import { render } from "./SongRankings.vue?vue&type=template&id=2e45cf65&scoped=true"
import script from "./SongRankings.vue?vue&type=script&lang=js"
export * from "./SongRankings.vue?vue&type=script&lang=js"

import "./SongRankings.vue?vue&type=style&index=0&id=2e45cf65&scoped=true&lang=css"

import exportComponent from "/Users/benjamin/Documents/GitHub/beatmania-app-structure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e45cf65"]])

export default __exports__